import { GridRenderCellParams } from '@mui/x-data-grid';
import {
  dimensionClassBaseUnit,
  DimensionClassOptions,
  UnitOfMeasureDetails,
  UnitOfMeasureOptions,
} from 'types/unitsOfMeasure';
import { convert } from 'utils/unitConversion';
import _ from 'lodash';

export function renderUnitOfMeasureCell(
  params: GridRenderCellParams
): JSX.Element {
  const unitOfMeasure =
    UnitOfMeasureDetails[params.row.dimensionUnit as UnitOfMeasureOptions];
  return (
    <>
      {Number(params.value || 0).toLocaleString('en-US')}{' '}
      {unitOfMeasure?.abbreviation || params.row.dimensionUnit}
    </>
  );
}

export function renderUnitOfMeasureWithDimensionValueCell(
  params: GridRenderCellParams
): JSX.Element {
  const value = params.value
    ? _.toNumber(params.value).toLocaleString('en-US')
    : '';
  const unitOfMeasure =
    UnitOfMeasureDetails[params.row.dimensionUnit as UnitOfMeasureOptions];
  const dimensionValue = _.toNumber(params.row.dimensionValue || 1);
  const valueString = unitOfMeasure
    ? `${_.toNumber(value).toLocaleString('en-US')} ${
        dimensionValue && dimensionValue > 1 ? `x${dimensionValue} ` : ''
      }${unitOfMeasure.abbreviation}`
    : value;
  return <>{valueString}</>;
}

export function renderConvertedUnitOfMeasureCell(
  normalizedValue: number,
  dimensionClass: DimensionClassOptions,
  unitOfMeasure: UnitOfMeasureOptions
): JSX.Element {
  return (
    <>
      {convertedUnitOfMeasureString(
        normalizedValue,
        dimensionClass,
        unitOfMeasure
      )}
    </>
  );
}

export function convertedUnitOfMeasureString(
  normalizedValue: number,
  dimensionClass: DimensionClassOptions,
  unitOfMeasure?: UnitOfMeasureOptions
): string {
  const toAbbreviation =
    UnitOfMeasureDetails[
      unitOfMeasure || dimensionClassBaseUnit[dimensionClass]
    ].abbreviation;
  const fromAbbreviation =
    UnitOfMeasureDetails[dimensionClassBaseUnit[dimensionClass]].abbreviation;
  const convertedValue = convert(Number(normalizedValue))
    .from(fromAbbreviation)
    .to(toAbbreviation);
  return `${convertedValue.toLocaleString('en-US')} ${toAbbreviation}`;
}
